module.exports = __webpack_public_path__ + "img/1-230109154133945.a8725c18.png";